import { humanizeFieldName } from './helpers'

export default {
  getMessage: field => `The ${humanizeFieldName(field)} cannot contain comma.`,
  validate (value) {
    return !value.includes(',')
  }
}
